import { useState, useEffect } from "react";

export default function StepOne({ data, setData }) {
  const [mealName, setMealName] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [price, setPrice] = useState("");

  useEffect(() => {
    const meals = data.meals || [];
    const newTotal = meals.reduce((sum, meal) => {
      return sum + meal.price * meal.quantity;
    }, 0);
    setData((prevData) => ({ ...prevData, total: newTotal.toFixed(2) }));
  }, [data.meals, setData]);

  const addMeal = () => {
    if (!mealName || !price) return;

    const newMeal = {
      name: mealName,
      quantity: parseInt(quantity),
      price: parseFloat(price),
      assigned: [],
    };

    const updatedMeals = [...(data.meals || []), newMeal];
    setData({ ...data, meals: updatedMeals });

    setMealName("");
    setQuantity(1);
    setPrice("");
  };

  const updateMeal = (index, field, value) => {
    const updatedMeals = [...data.meals];
    if (field === "quantity") {
      updatedMeals[index][field] = parseInt(value) || 1;
    } else if (field === "price") {
      updatedMeals[index][field] = parseFloat(value) || 0;
    } else {
      updatedMeals[index][field] = value;
    }
    setData({ ...data, meals: updatedMeals });
  };

  const removeMeal = (index) => {
    const updatedMeals = [...data.meals];
    updatedMeals.splice(index, 1);
    setData({ ...data, meals: updatedMeals });
  };

  return (
    <div>
      <h2 style={{ fontSize: "20px", marginBottom: "1rem" }}>
        Step 1: Enter SST and Meals
      </h2>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "0.75rem",
          marginBottom: "1rem",
        }}
      >
        <div style={{ ...currencyWrapperStyle, width: "100%" }}>
          <span style={currencyLabel}>RM</span>
          <input
            type="number"
            placeholder="Total Amount"
            value={data.total}
            readOnly
            style={{ ...currencyInputStyle, background: "transparent" }}
          />
        </div>
        <div style={{ ...currencyWrapperStyle, width: "100%" }}>
          <span style={currencyLabel}>RM</span>
          <input
            type="number"
            placeholder="SST Amount"
            value={data.sst}
            onChange={(e) => setData({ ...data, sst: e.target.value })}
            style={currencyInputStyle}
          />
        </div>
      </div>

      <h3 style={{ fontSize: "16px", marginBottom: "0.5rem" }}>Add Meal</h3>
      <div style={{ ...rowStyle, alignItems: "stretch" }}>
        <input
          type="text"
          placeholder="Meal Name"
          value={mealName}
          onChange={(e) => setMealName(e.target.value)}
          style={{ ...inputStyle, flex: "2 1 100px" }}
        />
        <div style={{ ...currencyWrapperStyle, flex: "1 1 60px" }}>
          <input
            type="number"
            placeholder="Qty"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            min="1"
            style={currencyInputStyle}
          />
        </div>
        <div style={{ ...currencyWrapperStyle, flex: "1 1 100px" }}>
          <span style={currencyLabel}>RM</span>
          <input
            type="number"
            placeholder="Price"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            style={currencyInputStyle}
          />
        </div>
        <button onClick={addMeal} style={addBtnStyle}>
          +
        </button>
      </div>

      {data.meals?.length > 0 && (
        <div
          style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}
        >
          {data.meals.map((meal, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                background: "#f0f0f0",
                borderRadius: "12px",
                padding: "0.5rem 0.75rem",
                gap: "0.5rem",
              }}
            >
              <input
                type="text"
                value={meal.name}
                onChange={(e) => updateMeal(index, "name", e.target.value)}
                placeholder="Meal Name"
                style={{ ...fieldInputStyle, flex: "2 1 100px" }}
              />
              <div style={{ ...currencyWrapperStyle, flex: "1 1 60px" }}>
                <input
                  type="number"
                  value={meal.quantity}
                  onChange={(e) =>
                    updateMeal(index, "quantity", e.target.value)
                  }
                  min="1"
                  style={currencyInputStyle}
                />
              </div>
              <div style={{ ...currencyWrapperStyle, flex: "1 1 100px" }}>
                <span style={currencyLabel}>RM</span>
                <input
                  type="number"
                  value={meal.price}
                  onChange={(e) => updateMeal(index, "price", e.target.value)}
                  step="0.01"
                  style={currencyInputStyle}
                />
                <button
                  onClick={() => removeMeal(index)}
                  style={{
                    background: "transparent",
                    border: "none",
                    fontSize: "16px",
                    color: "red",
                    cursor: "pointer",
                  }}
                >
                  ✕
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const rowStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "0.5rem",
  marginBottom: "1rem",
};

const inputStyle = {
  padding: "0.5rem",
  borderRadius: "8px",
  border: "1px solid #ccc",
  fontSize: "14px",
  width: "100%",
  boxSizing: "border-box",
};

const fieldInputStyle = {
  border: "none",
  background: "transparent",
  fontSize: "14px",
  outline: "none",
  width: "100%",
  boxSizing: "border-box",
};

const addBtnStyle = {
  background: "#4a90e2",
  color: "white",
  border: "none",
  padding: "0.5rem 0.8rem",
  borderRadius: "8px",
  fontSize: "18px",
  cursor: "pointer",
  flex: "0 0 auto",
};

const currencyWrapperStyle = {
  display: "flex",
  alignItems: "center",
  background: "#f5f5f5",
  borderRadius: "8px",
  padding: "0.5rem",
  border: "1px solid #ccc",
  boxSizing: "border-box",
};

const currencyLabel = {
  marginRight: "4px",
  fontWeight: "bold",
  fontSize: "14px",
  color: "#333",
  display: "flex",
  alignItems: "center",
};

const currencyInputStyle = {
  border: "none",
  background: "transparent",
  outline: "none",
  width: "100%",
  fontSize: "14px",
};
